export interface FormProps {
  search: string;
}

export default function mapPropsToValues() {
  return {
    search: "",
  };
}
